import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import MarketingLayout from './MarketingLayout';
import { SECTIONS, getAllArticles } from '../data/articles';

export default function KnowledgeCenter() {
  const [search, setSearch] = useState('');

  const allArticles = getAllArticles();

  // When searching, show a flat results list across all categories
  const searchResults = search.trim()
    ? allArticles.filter(a =>
        a.title.toLowerCase().includes(search.toLowerCase()) ||
        a.category.toLowerCase().includes(search.toLowerCase())
      )
    : [];

  const filteredSections = search.trim()
    ? SECTIONS.map(s => ({
        ...s,
        articles: s.articles.filter(a =>
          a.title.toLowerCase().includes(search.toLowerCase())
        ),
      })).filter(s => s.articles.length > 0)
    : SECTIONS;

  return (
    <MarketingLayout>
      {/* Hero */}
      <section style={{ padding: '80px 24px 60px', background: 'linear-gradient(180deg,#f8faff 0%,#fff 100%)', textAlign: 'center' }}>
        <div style={{ display: 'inline-block', background: '#fff7ed', color: '#d97706', fontSize: 12, fontWeight: 700, letterSpacing: '1.2px', textTransform: 'uppercase', padding: '5px 14px', borderRadius: 40, border: '1px solid #fde68a', marginBottom: 20 }}>
          Knowledge Center
        </div>
        <h1 style={{ fontSize: 48, fontWeight: 900, letterSpacing: '-2px', marginBottom: 16, color: '#0f172a' }}>
          How can we help?
        </h1>
        <p style={{ fontSize: 18, color: '#475569', marginBottom: 32 }}>
          Guides, documentation, and tutorials for ClickSaver.
        </p>
        <div style={{ maxWidth: 480, margin: '0 auto', position: 'relative' }}>
          <span style={{ position: 'absolute', left: 16, top: '50%', transform: 'translateY(-50%)', fontSize: 16, color: '#94a3b8' }}>🔍</span>
          <input
            type="text"
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder="Search articles..."
            style={{
              width: '100%', padding: '14px 16px 14px 44px', borderRadius: 12,
              border: '1.5px solid #e2e8f0', fontSize: 15, outline: 'none',
              fontFamily: 'inherit', boxShadow: '0 2px 8px rgba(0,0,0,.04)',
              boxSizing: 'border-box',
            }}
          />
          {search && (
            <button
              onClick={() => setSearch('')}
              style={{ position: 'absolute', right: 14, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8', fontSize: 18, lineHeight: 1 }}
            >×</button>
          )}
        </div>
        {search && (
          <p style={{ fontSize: 13, color: '#94a3b8', marginTop: 10 }}>
            {searchResults.length} result{searchResults.length !== 1 ? 's' : ''} for "{search}"
          </p>
        )}
      </section>

      {/* Video tutorials banner */}
      {!search.trim() && (
        <section style={{ padding: '0 24px 20px', background: '#fff' }}>
          <a
            href="https://www.youtube.com/@ClickSaver"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'flex', alignItems: 'center', gap: 20, maxWidth: 900, margin: '0 auto', padding: '20px 24px', background: 'linear-gradient(135deg,#fff5f5,#fff)', border: '1px solid #fecaca', borderRadius: 16, textDecoration: 'none', color: 'inherit', transition: 'transform .15s, box-shadow .15s' }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 20px 40px -20px rgba(220,38,38,0.2)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}
          >
            <div style={{ width: 56, height: 56, borderRadius: 14, background: '#dc2626', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <svg width="26" height="18" viewBox="0 0 24 17" fill="currentColor"><path d="M23.5 2.6a3 3 0 0 0-2.1-2.1C19.5 0 12 0 12 0S4.5 0 2.6.5A3 3 0 0 0 .5 2.6C0 4.5 0 8.5 0 8.5s0 4 .5 5.9a3 3 0 0 0 2.1 2.1C4.5 17 12 17 12 17s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.1c.5-1.9.5-5.9.5-5.9s0-4-.5-5.9z"/><path d="M9.5 12.1V4.9l6.3 3.6-6.3 3.6z" fill="#dc2626"/></svg>
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 16, fontWeight: 700, color: '#0f172a', marginBottom: 4 }}>Prefer video? Watch tutorials on YouTube</div>
              <div style={{ fontSize: 14, color: '#475569' }}>Setup walkthroughs, feature deep-dives, and case studies from the ClickSaver team.</div>
            </div>
            <div style={{ fontSize: 13, fontWeight: 600, color: '#dc2626', whiteSpace: 'nowrap' }}>Watch on YouTube →</div>
          </a>
        </section>
      )}

      {/* Search results — flat list */}
      {search.trim() && (
        <section style={{ padding: '20px 24px 60px', background: '#fff' }}>
          <div style={{ maxWidth: 720, margin: '0 auto' }}>
            {searchResults.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '48px 0' }}>
                <div style={{ fontSize: 40, marginBottom: 12 }}>🔍</div>
                <p style={{ color: '#64748b', fontSize: 16 }}>No articles found for "{search}"</p>
                <button onClick={() => setSearch('')} style={{ marginTop: 12, color: '#2563eb', background: 'none', border: 'none', cursor: 'pointer', fontSize: 14, fontWeight: 600 }}>
                  Clear search
                </button>
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {searchResults.map((a, i) => (
                  <Link
                    key={i}
                    to={`/knowledge-center/${a.slug}`}
                    style={{
                      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                      padding: '16px 20px', borderRadius: 10, textDecoration: 'none',
                      background: '#f8fafc', border: '1px solid #e2e8f0',
                      transition: 'background 0.15s',
                    }}
                    onMouseEnter={e => e.currentTarget.style.background = '#eff6ff'}
                    onMouseLeave={e => e.currentTarget.style.background = '#f8fafc'}
                  >
                    <div>
                      <div style={{ fontSize: 14, fontWeight: 600, color: '#0f172a', marginBottom: 3 }}>{a.title}</div>
                      <div style={{ fontSize: 12, color: a.categoryColor, fontWeight: 500 }}>{a.category}</div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
                      <span style={{ fontSize: 12, color: '#94a3b8' }}>{a.time}</span>
                      <span style={{ color: '#94a3b8', fontSize: 16 }}>→</span>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </section>
      )}

      {/* Category grid */}
      {!search.trim() && (
        <section style={{ padding: '40px 24px 100px', background: '#fff' }}>
          <div style={{ maxWidth: 1100, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 24 }}>
            {filteredSections.map((s, i) => (
              <div key={i} style={{ border: '1.5px solid #e2e8f0', borderRadius: 16, overflow: 'hidden' }}>
                <div style={{ background: s.bg, padding: '20px 24px', display: 'flex', alignItems: 'center', gap: 12 }}>
                  <div style={{ width: 40, height: 40, borderRadius: 10, background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20 }}>{s.icon}</div>
                  <h2 style={{ fontSize: 16, fontWeight: 700, color: '#0f172a', margin: 0 }}>{s.title}</h2>
                </div>
                <div style={{ padding: '8px 0' }}>
                  {s.articles.map((a, j) => (
                    <Link
                      key={j}
                      to={`/knowledge-center/${a.slug}`}
                      style={{
                        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                        padding: '12px 24px', textDecoration: 'none', transition: 'background .15s',
                        borderBottom: j < s.articles.length - 1 ? '1px solid #f8fafc' : 'none',
                      }}
                      onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                    >
                      <span style={{ fontSize: 14, color: s.color, fontWeight: 500 }}>{a.title}</span>
                      <span style={{ fontSize: 12, color: '#94a3b8', flexShrink: 0, marginLeft: 12 }}>{a.time}</span>
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>
      )}

      {/* Contact support */}
      <section style={{ padding: '40px 24px 80px', background: '#f8fafc', textAlign: 'center' }}>
        <h2 style={{ fontSize: 26, fontWeight: 800, letterSpacing: '-0.5px', marginBottom: 10 }}>
          Can't find what you're looking for?
        </h2>
        <p style={{ fontSize: 16, color: '#64748b', marginBottom: 24 }}>
          Our support team typically replies within 1 business day.
        </p>
        <a
          href="mailto:support@clicksaver.app"
          style={{ background: '#2563eb', color: '#fff', textDecoration: 'none', padding: '12px 28px', borderRadius: 10, fontSize: 15, fontWeight: 600 }}
        >
          Contact Support
        </a>
      </section>
    </MarketingLayout>
  );
}
